export const summaryRows: string[] = [
  'Volume 1 — Industry Fundamentals & Strategic Resources',
  'Volume 2 — Lithium Geology, Exploration & Resource Evaluation',
  'Volume 3 — Lithium Mining, Brine Production & Advanced Extraction Technologies',
  'Volume 4 — Lithium & Critical Minerals Processing and Refining Technologies',
  'Volume 5 — Battery Materials, Energy Storage Technologies & Industrial Applications',
  'Volume 6 — Critical Minerals Project Economics, Sustainability & Global Supply Chains',
  'Bonus 1 — 150 Essential Terms Technical Glossary',
  'Bonus 2 — Extraction Technology Comparison Guide',
  'Bonus 3 — 37 Calculation Examples Handbook',
  'Bonus 4 — 12 Industry Case Studies',
  'Bonus 5 — Global Critical Minerals Reference Atlas',
  '7-day money-back guarantee',
  'Instant access',
];
